/**
 * useTaskStates Hook
 *
 * Per-task state for minimap body colours (complete / active / available / …).
 */

import { useMemo } from 'react';
import { deriveFlowTaskVisualState } from '../../../utils/deriveFlowTaskVisualState';

/**
 * Hook for calculating task states for minimap highlighting
 */
export const useTaskStates = (tasks, statuses, lockStates, nestedSprints) => {
  const taskStates = useMemo(() => {
    const getNestedSprint = (task) => {
      if (!task.nestedSprintId) return null;
      return nestedSprints.find((ns) => ns.id === task.nestedSprintId) || null;
    };

    const states = {};
    tasks.forEach((task) => {
      states[task.id] = deriveFlowTaskVisualState(
        task,
        statuses,
        lockStates[task.id],
        getNestedSprint(task)
      );
    });
    return states;
  }, [tasks, statuses, lockStates, nestedSprints]);

  return taskStates;
};

export default useTaskStates;
